// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1cHQZ","productName":"Table_productName__3O7mv"};